import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { IDropdownOptions, SharedDataService } from '../../@core/service/shared-data.service';
import { IssuerData, CountryCodes, DateSelectionData, OfferStatusData } from '../../@models/erp/compilationData';
import { ApiService } from '../../@core/service/api.service';
import { ReportsComponent } from '../erp/reports/reports.component';
import { AuthGuardService } from '../../@core/service/auth-guard.service';
import { ReportsPrinterComponent } from '../erp/reports/reports-printer/reports-printer.component';
import { EBusinessType, EContactType } from '../../@models';
import { ActivatedRoute } from '@angular/router';
import { mongoId } from '../../@core/common/global';
import { EventService } from '../../@core/service/eventService';
import * as moment from 'moment';

@Component({
  selector: 'app-openorders',
  templateUrl: './offers.component.html',
  styleUrls: ['./offers.component.scss']
})
export class OffersComponent implements OnInit, AfterViewInit {

  @ViewChild('reportsPrinter') reportsPrinter: ReportsPrinterComponent;

  search: any;

  customerReferenceOptions = null;
  finishedProductOptions = null;

  finishedProductBusinessId = null;
  finishedProductOptionsMulti = [];

  issuerOptions = IssuerData.getOptions();
  countryOptions = CountryCodes.getOptions();

  employeeOptions: IDropdownOptions[] = [];

  offerStati = [{id: null, name: 'undefined'}, ...OfferStatusData.getStati()];

  loading = true;

  subscriptions = [];

  filter = {
    issuer: null,
    country: null,
    customers: [],
    customerDocumentNumbers: [],
    finishedProducts: [],
    businessUnits: [],
    relatedSPOs: 2,
    showMarkup: 1,
    sampleRequest: 0,
    manager: null,
    // sortOrder: EBusinessStatus.new,
    offerStatus: [ true, true, true, true, true, true, false, true ]
  }

  constructor(
    protected data: SharedDataService,
    protected api: ApiService,
    private auth: AuthGuardService,
    private cdRef: ChangeDetectorRef,
    private route: ActivatedRoute,
    private event: EventService,
  ) { }

  ngOnInit() {

    this.data.loadUsers();
    this.data.loadBusinessUnits();
    this.data.loadBusinesses();
    this.data.loadProducts();
    this.data.loadContacts().then((contacts) => {
      this.employeeOptions = contacts.filter(f => f.business?.type === EBusinessType.NRK && f.type === EContactType.Employee).map(m => ({id: m._id, name: m.displayTitle}))
    })
    this.filter.manager = mongoId(this.auth.user?.contact) || null;
    // this.filter.sortOrder = 10;
    this.reload()

  }

  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }


  async customersChanged(customerIds: string[]) {
    if (customerIds && customerIds.length) {
      this.api.getCustomerDocRefs(customerIds).then(customerRefs =>
        this.customerReferenceOptions = customerRefs.map(m => ({
          id: m.customerDocumentNumber,
          name: `${m.customerDocumentNumber} | ${m.nameOverride || m.code} | ${m.issueDate.split('T')[0]}`,
        })).filter(f => f.id)
      );

      const finishedProducts = await this.api.getCustomerFinishedProducts(customerIds);
      this.finishedProductOptions = finishedProducts.map(m => ({
        id: m._id,
        name: `${m.calcCode} | ${m.calcName} || ${m.externalCode} | ${m.externalName}`,
      }));
    }
  }

  reload(alternateView = false) {
    // console.log('sort order: ', this.filter.sortOrder)
    const search = { offers: JSON.parse(JSON.stringify(ReportsComponent.defaultReport.offers)) }
    search.offers.orientation= 'portrait';
    // dateType = DateSelectionData.currentYear.id,
    search.offers.manager = this.filter.manager; // this.auth.user && this.auth.user.erpRoles && this.auth.user.erpRoles.dashboardType === 1 ? this.auth.user.contact : null;
    search.offers.issuer = this.filter.issuer;
    search.offers.country = this.filter.country;
    search.offers.customers = this.filter.customers;
    search.offers.customerDocumentNumbers = this.filter.customerDocumentNumbers;
    search.offers.businessUnits = this.filter.businessUnits;
    search.offers.finishedProducts = this.filter.finishedProducts;
    search.offers.filterInternal = true;
    search.offers.sampleRequest = 3;
    search.offers.limit = 0;
    search.offers.offerStatus = this.filter.offerStatus
    // search.offers.sortOrder = this.filter.sortOrder;
    search.offers.dateFrom = null; // moment().subtract(1, 'month').toDate(); // null; //new Date('2016-01-01');
    search.offers.dateTo = null; //new Date();
    search.offers.fromMainMenu = true;


    if (alternateView) {
      search.offers = {
        ...search.offers,
        dateFrom: moment(new Date()).subtract(2, 'months').toDate(),
        dateTo: new Date(),
        sortByManager: true,
        sampleRequest: 3, // no SR
        filename:`${moment().format('YYMMDD')}_OF`,
      }
    }

    this.search = search;

    console.log('search', this.search, search, this.search.offers.customers);
    this.cdRef.detectChanges();
    this.reportsPrinter.reloadData(true);

  }

  reportLoaded() {
    this.loading = false;
  }


}
